<template>
	<div class="account page-container">
		<custom-table :pageConfig="pageConfig" :multipleSelection="multipleSelection" :buttonGroup="buttonGroup"
			:filterValue="filterValue" :tableFilter="tableFilter" :tableConfig="tableConfig" :tableData="tableData"
			@pageChange="pageChange" @buttonClick="buttonClick" @filterChange="filterChange"
			@scopeButtonClick="scopeButtonClick">
		</custom-table>
		<!-- 编辑信息 -->
		<el-dialog title="账号信息" :visible.sync="dialogFormVisible" width="500px" custom-class="generalDialog"
			@close="dialogFormVisible = false">
			<el-form ref="accountForm" :model="accountForm" :label-width="accountFormLabelWidth"
				:rules="accountFormRules">
				<el-form-item label="用户账号" prop="account">
					<el-input v-model="accountForm.account" autocomplete="off" placeholder="请输入账号" clearable></el-input>
				</el-form-item>
				<el-form-item label="用户名" prop="username">
					<el-input v-model="accountForm.username" autocomplete="off" placeholder="请输入用户名" clearable>
					</el-input>
				</el-form-item>
				<el-form-item label="密码" prop="password" v-if="operationId == ''">
					<el-input type="password" v-model="accountForm.password" autocomplete="off" placeholder="请输入密码"
						clearable></el-input>
				</el-form-item>
				<el-form-item label="账号状态" prop="status">
					<el-select v-model="accountForm.status" placeholder="请选择账号状态" clearable>
						<el-option v-for="(item,index) in statusList" :key="index" :label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="DialogClose('accountForm')">取 消</el-button>
				<el-button type="primary" :loading="loading" @click="DialogConfirm('accountForm')">确 定</el-button>
			</div>
		</el-dialog>
		<!-- 修改用户密码 -->
		<el-dialog title="修改用户密码" :visible="passwordFormVisible" width="500px" custom-class="generalDialog"
			@close="passwordFormVisible = false">
			<el-form ref="passwordForm" :model="passwordForm" :label-width="accountFormLabelWidth"
				:rules="passwordRules">
				<el-form-item label="密码" prop="password">
					<el-input type="password" v-model="passwordForm.password" autocomplete="off" placeholder="请输入密码"
						clearable></el-input>
				</el-form-item>
				<el-form-item label="确认密码" prop="rptpassword">
					<el-input type="password" v-model="passwordForm.rptpassword" autocomplete="off" placeholder="请输入密码"
						clearable></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="DialogClose('passwordForm')">取 消</el-button>
				<el-button type="primary" :loading="loading" @click="DialogConfirm('passwordForm')">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: 'account',
		data() {
			let verify_account = (rule, value, callback) => {
				if (this.accountForm.account == '') {
					callback(new Error('请输入账号'))
				} else {
					if (this.accountForm.account.length < 8 || this.accountForm.account.length > 18) {
						callback(new Error('请输入8-18位账号'))
					}
					callback()
				}
			}
			let verify_password = (rule, value, callback) => {
				if (!this.$ver.verify_password(this.accountForm.password)) {
					callback(new Error('请输入6-18位密码'))
				} else {
					callback()
				}
			}
			let verify_password2 = (rule, value, callback) => {
				if (!this.$ver.verify_password(this.passwordForm.password)) {
					callback(new Error('请输入6-18位密码'))
				} else {
					callback()
				}
			}
			let verify_rptpassword = (rule, value, callback) => {
				if (this.passwordForm.password != this.passwordForm.rptpassword) {
					callback(new Error('两次输入的密码不一致'))
				} else {
					callback()
				}
			}
			return {
				dialogFormVisible: false,
				accountForm: {
					account: '',
					username: '',
					password: '',
					permission: '',
					status: ''
				},
				permissionList: [{
						label: '超级管理员',
						value: 1
					},
					{
						label: '操作员',
						value: 2
					}
				],
				statusList: [{
					label: '启用',
					value: 1
				}, {
					label: '禁用',
					value: 2
				}],
				accountFormLabelWidth: '80px',
				accountFormRules: {
					account: [{
						required: true,
						trigger: 'blur',
						validator: verify_account
					}],
					username: [{
						required: true,
						trigger: 'blur',
						message: '请输入用户名'
					}],
					password: [{
						required: true,
						trigger: 'blur',
						validator: verify_password
					}],
					permission: [{
						required: true,
						trigger: 'blur',
						message: '请选择账号权限'
					}],
					status: [{
						required: true,
						trigger: 'blur',
						message: '请选择账号状态'
					}],
				},
				loading: false,
				pageConfig: {
					totalWord: '全部数据',
					total: 0,
					pageSize: 13,
					currentPage: 1,
				},
				multipleSelection: [],
				buttonGroup: [{
					type: 'primary',
					size: 'mini',
					plain: true,
					icon: 'el-icon-plus',
					word: '添加用户',
					sign: 'new'
				}],
				filterValue: {},
				tableFilter: [],
				tableConfig: {
					border: true,
					selection: false,
					showOverflowTooltip: true,
					tableHeader: [{
							prop: 'username',
							label: '用户账号',
							width: 350
						},
						{
							prop: 'realName',
							label: '用户名',
							width: 350
						},
						{
							prop: 'createAt',
							label: '创建时间',
							width: 250
						},
						{
							prop: 'userStatus',
							label: '当前状态',
							width: 250,
							template: true
						}
					],
					tableEvent: [{
							icon: 'el-icon-edit',
							name: '编辑',
							color: 'blue',
							sign: 'edit'
						},
						{
							icon: 'el-icon-lock',
							name: '修改密码',
							color: 'blue',
							sign: 'lock'
						},
						{
							icon: 'el-icon-open',
							name: '修改状态',
							color: 'blue',
							sign: 'open'
						},
						{
							icon: 'el-icon-delete',
							name: '删除',
							color: 'red',
							sign: 'delete'
						}
					],
					emptyDescription: '当前没有数据',
				},
				tableData: [],
				passwordForm: {
					password: '',
					rptpassword: ''
				},
				passwordFormVisible: false,
				passwordRules: {
					password: [{
						required: true,
						trigger: 'blur',
						validator: verify_password2
					}],
					rptpassword: [{
						required: true,
						trigger: 'blur',
						validator: verify_rptpassword
					}],
				},
				operationId: ''
			};
		},
		methods: {
			pageChange() {
				this.fetchData()
			},
			buttonClick(sign) {
				if (sign === 'new') {
					this.dialogFormVisible = true
				}
			},
			filterChange() {
				console.log(this.filterValue);
			},
			scopeButtonClick(row, sign) {
				this.operationId = row.userId
				if (sign === 'edit') {
					this.accountForm = {
						account: row.username,
						username: row.realName,
						password: row.password,
						status: row.userStatus
					}
					this.dialogFormVisible = true
				}
				if (sign === 'lock') {
					this.passwordFormVisible = true
				}
				if (sign === 'open') {
					this.switchStatus(row)
				}
				if (sign === 'delete') {
					this.confirmDelete(row)
				}
			},
			DialogClose(formName) {
				if (formName === 'accountForm') {
					this.dialogFormVisible = false
				} else {
					this.passwordFormVisible = false
				}
			},
			DialogConfirm(formName) {
				this.$refs[formName].validate(valid => {
					if (valid) {
						this.loading = true
						if (formName == 'accountForm') {
							this.saveAccountInfo()
						} else {
							this.savePassword()
						}

					}
				})
			},
			saveAccountInfo() {
				this.$api.admUserAdd({
					userType: 2,
					username: this.accountForm.account,
					realName: this.accountForm.username,
					password: this.accountForm.password,
					userStatus: this.accountForm.status,
					userId: this.operationId
				}, res => {
					this.loading = false
					this.$refs.accountForm.resetFields()
					this.operationId = ''
					if (res.code == 200) {
						this.DialogClose('accountForm')
						this.fetchData()
						this.$message({
							message: (this.operationId == '' ? '新增' : '编辑') + '用户成功！',
							duration: 2000,
							type: 'success',
							onClose: () => {

							}
						})
					}
				})
			},
			savePassword() {
				this.$api.admPasswordEdit({
					password: this.passwordForm.password,
					userId: this.operationId
				}, res => {
					this.loading = false
					this.$refs.passwordForm.resetFields()
					this.operationId = ''
					if (res.code == 200) {
						this.DialogClose('passwordForm')
						this.fetchData()
						this.$message({
							message: '修改密码成功！',
							duration: 2000,
							type: 'success',
							onClose: () => {

							}
						})
					}
				})
			},
			switchStatus(row) {
				if (row.username == sessionStorage.getItem('account')) {
					this.$message({
						message: '您不能更改自己的账号状态',
						type: 'error',
						duration: 2000
					})
					return
				}
				let status = row.userStatus
				let msg = ''
				let result = ''
				if (status == 1) {
					msg = '确认要禁用这个账号吗？'
					result = '禁用成功。'
				} else {
					msg = '确认要启用这个账号吗？'
					result = '启用成功。'
				}
				this.$confirm(msg, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.admUserStatus({
						userId: this.operationId
					}, res => {
						this.operationId = ''
						if (res.code == 200) {
							this.fetchData()
							this.$message({
								message: result,
								type: 'success',
								duration: 2000
							})
						}
					})
				}).catch(() => {});
			},
			confirmDelete(row) {
				if (row.username == sessionStorage.getItem('account')) {
					this.$message({
						message: '您不能删除自己的账号',
						type: 'error',
						duration: 2000
					})
					return
				}
				this.$confirm('确认要删除这个账号吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.admUserDelete({
						userId: this.operationId
					}, res => {
						this.operationId = ''
						if (res.code == 200) {
							this.fetchData()
							this.$message({
								message: '删除成功',
								type: 'success',
								duration: 2000
							})
						}
					})
				}).catch(() => {});
			},
			// 获取用户列表
			fetchData() {
				this.$api.admUserList({
					pageSize: this.pageConfig.pageSize,
					pageNum: this.pageConfig.currentPage
				}, res => {
					if (res.code == 200) {
						this.pageConfig.total = res.data.total
						this.tableData = res.data.list
					}
				})
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			this.fetchData()
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	};
</script>

<style lang="less" scoped="scoped">

</style>
